import { RiLayout2Line, RiLineChartLine, RiMapPin2Fill, RiMoneyEuroCircleLine } from 'component-library';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { MenuItemProps } from '@/components/SignedInNavbar/Menu';
import { useIsConservation } from '@/hooks/useIsConservation';
import { usePathSet } from '@/hooks/usePathSet';

export const useMenuItems = () => {
  const { t } = useTranslation();
  const isConservation = useIsConservation();
  const pathSet = usePathSet();

  return useMemo(() => {
    const createMenuItem = (name: string, text: string, icon: JSX.Element, to: string): MenuItemProps => ({
      active: false,
      icon,
      name,
      text,
      to,
    });

    const menuItems: MenuItemProps[] = [
      createMenuItem('projects', t('navbar.projects'), <RiLayout2Line className='h-6 w-6' />, pathSet.projects),
      createMenuItem(
        'investments',
        t('navbar.investments'),
        <RiMoneyEuroCircleLine className='h-6 w-6' />,
        pathSet.investments,
      ),
      createMenuItem('portfolio', t('navbar.portfolio'), <RiLineChartLine className='h-6 w-6' />, pathSet.portfolio),
    ];

    if (!isConservation) {
      const plotsMenuItem = createMenuItem(
        'plots',
        t('navbar.plots'),
        <RiMapPin2Fill className='h-6 w-6' />,
        pathSet.plots,
      );
      menuItems.splice(1, 0, plotsMenuItem);
    }
    return menuItems;
  }, [t, pathSet.projects, pathSet.investments, pathSet.portfolio, pathSet.plots, isConservation]);
};
